// extracted by mini-css-extract-plugin
export default {"Overlay":"FwiHfslg","FloatingOverlay":"IZkAZbMP","OverlayContainer":"NNV78rNb","OverlayContainerContent":"MgjrQBpL","OverlaySurface":"mwmOKD3t"};